<div
  class="app-header header top-header"
  [ngClass]="{ 'dark-mode': isDarkMode, 'pi-sun': !isDarkMode }"
>
  <div class="container-fluid main-container">
    <div class="d-flex">
      <div class="dropdown side-nav">
        <a
          aria-label="Hide Sidebar"
          class="app-sidebar__toggle"
          data-bs-toggle="sidebar"
          (click)="toggleSidebar()"
        >
          <a class="open-toggle" href="javascript:void(0)">
            <i class="bx bx-menu-alt-left header-icon"></i>
          </a>
          <a class="close-toggle" href="javascript:void(0)">
            <i class="bx bx-x header-icon"></i>
          </a>
        </a>
      </div>
      <a class="header-brand" routerLink="/dashboard/sales">
        <img
          src="./assets/images/brand/lotep.svg"
          *ngIf="!isDarkMode"
          class="header-brand-img desktop-lgo"
          alt="DigitoPay Logo"
        />
        <img
          src="./assets/images/brand/logo-dark4.svg"
          *ngIf="isDarkMode"
          class="header-brand-img dark-logo"
          alt="DigitoPay Logo"
        />
        <img
          src="./assets/images/brand/icon.svg"
          class="header-brand-img mobile-logo"
          alt="DigitoPay Logo"
        />
      </a>
      <div class="d-flex order-lg-2 ms-lg-auto">
        <div
        class="navbar navbar-expand-lg navbar-nav-right responsive-navbar navbar-dark p-0"
        >
          <app-country-info  class="mt-3 mt-lg-0"></app-country-info >
          <app-language-selector class="mt-3 mt-lg-0"></app-language-selector>
          <h2 class="user-name fs-14 float-end font-weight-bold font-italic">
            {{ 'common.hello' | translate}} {{ userName }}
          </h2>
          <div class="" id="navbarSupportedContent-4">
            <div class="d-flex order-lg-2">
              <div ngbDropdown class="dropdown profile-dropdown">
                <a
                  ngbDropdownToggle
                  href="javascript:void(0)"
                  class="nav-link icon px-1"
                  data-bs-toggle="dropdown"
                >
                  <i class="fe fe-settings"></i>
                </a>
                <div
                  ngbDropdownMenu
                  class="dropdown-menu dropdown-menu-end dropdown-menu-arrow animated"
                >
                  <div
                    class="dropdown-header noti-title text-center border-bottom p-3"
                  >
                    <div ngbDropdownItem class="header-usertext">
                      <h5 class="mb-1 menu-company">{{ company }}</h5>
                      <p class="mb-1">{{ userName }}</p>
                    </div>
                  </div>
                  <a
                    ngbDropdownItem
                    class="dropdown-item"
                    routerLink="/account/view"
                  >
                    <i class="fe fe-user me-2"></i> <span>{{ 'common.myAccount' | translate}}</span>
                  </a>
                  <a ngbDropdownItem class="dropdown-item" (click)="logOut()">
                    <i class="fe fe-x me-2"></i> <span>Logout</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
